import React from "react";
import { Modal } from "react-bootstrap";
import "./Vendor_Login_History_Modal.css";
import { IDS } from "../../../../../utils/IDS";

const Vendor_Login_History_Modal = ({ show, handleClose, data }) => {
  console.log(data, "datadata");

  const record = data || {
    name: "Saurabh Dalvi",
    mobile: "+91 5479565845",
    whatsapp: "+91 5658456854",
    img: "/assets/images/expert1.png",
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      contentClassName="history-popup-overlay__content"
      className="history-popup-overlay"
    >
      <Modal.Body className="history-popup-overlay__body">
        <div className="history-popup-overlay__card">
          <div className="history-popup-overlay__thumbnail">
            {/* <img
              src={`${IDS?.IMG_URL}${record?.construction_image}`}
              alt={record?.name}
              className="history-popup-overlay__img"
            /> */}
            <img
              src={
                record?.construction_image
                  ? `${IDS?.IMG_URL}${record.construction_image}`
                  : "/assets/images/vendors/vendor1.png"
              }
              alt={record?.name || "Vendor"}
              className="history-popup-overlay__img"
              onError={(e) => {
                e.target.src = "/assets/images/vendors/vendor1.png";
              }}
            />
          </div>
          <div className="history-popup-overlay__details-box">
            <h4 className="history-popup-overlay__vendor-title">
              {record.name}
            </h4>
            <div className="history-popup-overlay__contact-rows">
              <div className="history-popup-overlay__entry">
                <span className="history-popup-overlay__key">
                  Mobile Number :-
                </span>
                <span className="history-popup-overlay__val">
                  {record?.mobile_number}
                </span>
              </div>
              {/* <div className="history-popup-overlay__entry">
                <span className="history-popup-overlay__key">
                  Whatsapp No :-
                </span>
                <span className="history-popup-overlay__val">
                  {record?.whatsapp_number}
                </span>
              </div> */}
            </div>
            <div className="history-popup-overlay__action-area">
              <button
                className="history-popup-overlay__btn-dismiss"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default Vendor_Login_History_Modal;
